import { createContext, useContext } from 'react';

import { CodingProblemProps } from './types';

const codingPropsContext = createContext({} as CodingProblemProps);

export const CodingPropsProvider = codingPropsContext.Provider;

export function useCodingProblemProps() {
    return useContext(codingPropsContext);
}

// try https://github.com/dai-shi/use-context-selector
export function useCodingPropsSelector<T>(selector: (state: CodingProblemProps) => T): T {
    return selector(useCodingProblemProps());
}
